<div id="ampeditenduser" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="inner-subBlock-wrapper">
      <div class="container">
        <div class="row" [formGroup]="userFormGroup">
          <div class="container" formGroupName="userGroup">
            <label class="title">Customer Details</label>
            <!-- org section -->
            <div style="margin: 20px 0px 50px 25px;">
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="companyNameValidate" formControlName="companyNameField" placeholder="Customer Name"
                    required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <mat-select placeholder="Market Segment" class="marketSegmentValidate" formControlName="marketSegmentField" required>
                      <mat-option value="COM">
                          COMMERCIAL
                      </mat-option>
                      <mat-option value="EDU">
                          EDUCATION
                      </mat-option>
                      <mat-option value="GOV">
                          GOVERNMENT
                      </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            
            <!-- address section -->
            <div style="margin: 20px 0px 50px 25px;">
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput id = "addressLine1" class="addressLine1Validate" formControlName="addressLine1Field"
                  (change)="omit_nonprintable_char($event)" placeholder="Address Line 1" required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput id = "addressLine2" class="addressLine1Validate" formControlName="addressLine2Field"
                  (change)="omit_nonprintable_char($event)" placeholder="Address Line 2">
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput id = "addressLine3" class="addressLine1Validate" formControlName="addressLine3Field"
                  (change)="omit_nonprintable_char($event)" placeholder="Address Line 3">
                </mat-form-field>

                <mat-form-field [floatLabel]="'always'" class="col">
                  <mat-select placeholder="State" formControlName="stateField" required>
                      <mat-option *ngFor="let s of stateList" [value]="s">
                          {{s}}
                      </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger"
                    (input)="onInputSub($event)" [matAutocomplete]="autoSuburb" formControlName="suburbField"
                    placeholder="Suburb" (keydown.Tab)="chooseAutoCompletSuburb($event)" (suburb)="startFilterSub($event)" 
                    required>
                  <mat-autocomplete #autoSuburb="matAutocomplete">
                    <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="postcodeValidate" #myAutocompleteTriggerPostcode="matAutocompleteTrigger"
                    (input)="onInputPostcode($event)" maxlength="4" (keypress)="isNumberKey($event)"
                    formControlName="postcodeField" (postcode)="startFilterPostcode($event)"
                    (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode"
                    placeholder="Postcode" required>
                  <mat-autocomplete #autoPostcode="matAutocomplete">
                    <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
                      (click)="chooseAutoComplete(option)">
                      {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>

            <label class="title">Contact Details</label>
            <!-- contact section -->
            <div style="margin: 20px 0px 50px 25px;">
              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="firstNameValidate" formControlName="firstNameField" placeholder="First Name"
                    required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="lastNameValidate" formControlName="lastNameField" placeholder="Last Name" required>
                </mat-form-field>
              </div>

              <div class="row">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput class="emailValidate" formControlName="emailField" placeholder="Email Address" required>
                </mat-form-field>
                <mat-form-field [floatLabel]="'always'" class="col">
                  <input matInput (keypress)="isNumberKey($event)" class="phoneValidate" formControlName="phoneField"
                    placeholder="Phone" required>
                </mat-form-field>
              </div>
            </div>

            <!-- coterm date -->
            <div class="row" *ngIf="details?.customer?.is_coterm">
              <div class="col-sm">
                <label class="lable-title"> Anniversary Date</label>
                <p class="paragraph-text">{{ details?.customer?.coterm_date | date: 'dd/MM/yyyy'}}</p>
              </div>
            </div>

            <!-- <div style="margin: 50px 0;">
              <div class="row" style="padding-bottom: 1.5rem;">
                <mat-slide-toggle
                  class="col"
                  (change)="toggleCommitment()"
                  formControlName="cotermToggle"
                >
                Custom Anniversary Date &nbsp;&nbsp;
                <mat-icon matSuffix
                  class="editmpnidicon"
                  style="font-size: 14px; line-height: unset;"
                  placement="bottom"
                  ngbTooltip="You can either choose co-term or commitment"
              >
              info</mat-icon>
                </mat-slide-toggle>

              </div>

              <div class="row" *ngIf="userFormGroup.get('userGroup.cotermToggle')?.value">
                <div class="col">
                    <div style="margin-bottom: 1.5rem;">The standard initial subscription term is 12 months from the first order. If your customer requires an extended paid-up-front term, please select the desired anniversary date below.</div>
                    <mat-form-field style="width: 20%;">
                      <input matInput [matDatepicker]="picker" [formControl]="cotermControl">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>


                  <div style="margin-top: 1.5rem;">Initial License Subscription Period: 13 months. Any renewal License Subscription Period will be 12 months beginning on the Anniversary Date.</div>
                </div>
                

                <div class="col">

                </div>
              </div>
            </div> -->
          
            <!-- commitment section -->
            <div style="margin: 50px 0;">
              <div class="row" style="padding-bottom: 1.5rem;">
                <mat-slide-toggle class="col" (change)="toggle3yCommit(details?.customer?.coterm_date)" formControlName="commmitmentToggle">
                  3 Year Commit
                </mat-slide-toggle>
                <div class="col">
                  <span>
                    Adobe 3 Year Commit entitles customers to discounted pricing for future purchases and renewals in exchange for a minimum license commitment
                  </span>
                </div>
              </div>

              <div class="row" *ngIf="userFormGroup.get('userGroup.commmitmentToggle')?.value">
                <mat-form-field [floatLabel]="'always'" class="col">
                  <mat-select placeholder="{{getNoOfLicensePlaceHolder()}}" class="noOfLicenseCommitmentsValidate" formControlName="noOfLicenseCommitments">
                    <mat-option value="10">
                      10
                    </mat-option>
                    <mat-option value="50">
                      50
                    </mat-option>
                    <mat-option value="100">
                      100
                    </mat-option>
                    <mat-option *ngIf="extra3YCOption" value="{{extra3YCOption}}">
                      {{extra3YCOption}}
                    </mat-option>
                  </mat-select>
                  <!-- <input matInput class="commitmentsValidate" formControlName="noOfLicenseCommitments" placeholder="No. of License Commitment"> -->
                </mat-form-field>
                <div class="col"></div>
                <!-- <mat-form-field [floatLabel]="'always'" class="col" >
                  <input matInput class="noOfConsumablesCommitmentsValidate" formControlName="noOfConsumablesCommitments"
                    placeholder="No. of Consumables Commitment">
                </mat-form-field> -->
              </div>
            </div>
        </div>


        <div class="button-center" style="width: 100%;">
          <button
            [disabled]="!authService?.currentUserHasPurchaseAccess()"
            [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"  
            matTooltip="Requires Purchasing Permissions"
            class="button button-red button-large"
            (click)="updateEndUser()">Update</button>
        </div>
        <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false" backDropWidth="984" (currentLoadingStatus)="onLoading($event)"></loading-screen>
      </div>
    </div>
  </div>
</div>